class TeamsStore {
  constructor() {
    this.state = {
      newFormVisible: false,
      editFormVisible: false,
    };
  }
}

export default new TeamsStore();



// WEBPACK FOOTER //
// ./modules/teams/store.js